import gql from 'graphql-tag';

const GET_POLICY_SET_SYS = gql`
  query getPolicy($policyId: ID!) {
    getPolicy(policyId: $policyId) {
      policyId
      name
      description
      enabled
      agentSettingsConfig {
        systemTrayIconConfig {
          iconId
          name
          description
          logoFileName
          menus {
            menuId
            type
            name
            toolTipText
            aboutMessage
            url
            menuOrder
            ticketFormId
            scripts {
              script {
                scriptId
                name
                description
              }
              type
              arguments
            }
          }
        }
      }
    }
  }
`;

const UPDATE_SYSTEM_TRAY = gql`
  mutation updateSystemTray(
    $policySetId: ID!
    $category: PolicySetCategory!
    $input: PolicySetInput!
    $clientId: ID
    $siteId: ID
    $assetId: ID
  ) {
    updatePolicySet(
      policySetId: $policySetId
      category: $category
      input: $input
      clientId: $clientId
      siteId: $siteId
      assetId: $assetId
    ) {
      policySetId
    }
  }
`;

const CREATE_POLICY_SET_SYS_TRAY = gql`
  mutation($input: PolicySetInput) {
    createPolicySet(input: $input) {
      policySetId
    }
  }
`;

export { GET_POLICY_SET_SYS, UPDATE_SYSTEM_TRAY, CREATE_POLICY_SET_SYS_TRAY };
